import { useEffect, useState } from "react";
import { useI18n } from "../i18n/LanguageContext";
import { Icon } from "./Icon";
import styles from "./BackToTop.module.css";

export function BackToTop() {
  const { ui } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      className={`${styles.btn} ${visible ? styles.visible : ""}`}
      onClick={() =>
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
            ? "auto"
            : "smooth",
        })
      }
      aria-label={ui.a11y.backToTop}
      tabIndex={visible ? 0 : -1}
    >
      <Icon name="arrow-up" />
    </button>
  );
}
